import { render, staticRenderFns } from "./date-component.vue?vue&type=template&id=318bcc5e&scoped=true"
import script from "./date-component.vue?vue&type=script&lang=js"
export * from "./date-component.vue?vue&type=script&lang=js"
import style0 from "./date-component.vue?vue&type=style&index=0&id=318bcc5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318bcc5e",
  null
  
)

export default component.exports